var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca class=\"lv-item\" href=\"\" ui-sref=\"calendar.main.add\"\u003E\u003Cli\u003E{{ 'Add a new calendar' | translate }}\u003C\u002Fli\u003E\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;